import { RepositoryOnboardingProgress } from "../components/RepositoryOnboardingProgress"

export function RepositoryOnboardingPage(props) {
  return <RepositoryOnboardingProgress {...props} />
}
